var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-page"},[_c('div',{staticClass:"auth-page__form"},[_c('spotley-header'),_c('signup-form')],1),_c('div',{staticClass:"auth-page__bg-image"})])}
var staticRenderFns = []

export { render, staticRenderFns }